<script src="../../router/index.js"></script>
<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{ $t("login.login") }}</div>
<!--      <div class="language" @click="$router.push('/language')">-->
<!--        <img :src="require('../images/language/' + lang + '.png')" />-->
<!--      </div>-->
      <div class="title-img">
        <svg style="height: 32px" viewBox="0 0 164 30"><defs><path id="a" d="M157.725 29.99H.01V.048h157.715z"></path></defs><g fill="none" fill-rule="evenodd"><path d="M160.352 24.069v-.449h.288c.157 0 .371.012.371.204 0 .208-.11.245-.296.245h-.363m0 .315h.192l.447.784h.49l-.494-.816c.255-.019.465-.14.465-.484 0-.427-.295-.565-.793-.565h-.721v1.865h.414v-.784m2.098-.146c0-1.095-.851-1.73-1.8-1.73-.955 0-1.805.635-1.805 1.73s.85 1.733 1.805 1.733c.948 0 1.8-.638 1.8-1.733m-.52 0c0 .798-.587 1.334-1.28 1.334v-.006c-.713.006-1.289-.53-1.289-1.328 0-.797.577-1.331 1.289-1.331.694 0 1.28.534 1.28 1.331" fill="#fff"></path><mask id="b" fill="#fff"><use href="#a"></use></mask><path d="m96.374 5.707.002 19.66h5.552V5.707h-5.554zm-43.677-.026v19.686H58.3V10.086l4.37.014c1.437 0 2.43.345 3.123 1.084.879.936 1.237 2.444 1.237 5.205v8.978h5.427V14.49c0-7.763-4.948-8.81-9.789-8.81h-9.97zm52.617.027v19.659h9.006c4.798 0 6.364-.798 8.057-2.587 1.198-1.256 1.971-4.014 1.971-7.027 0-2.763-.655-5.228-1.797-6.763-2.057-2.745-5.02-3.282-9.445-3.282h-7.792zm5.508 4.28h2.387c3.463 0 5.703 1.556 5.703 5.591 0 4.037-2.24 5.592-5.703 5.592h-2.387V9.989zm-22.453-4.28-4.634 15.58-4.44-15.579-5.993-.001 6.34 19.659h8.003l6.391-19.659H88.37zm38.563 19.659h5.553V5.709l-5.555-.001.002 19.659zm15.564-19.652-7.753 19.645h5.475l1.227-3.472h9.175l1.161 3.472h5.944l-7.812-19.646-7.417.001zM146.1 9.3l3.364 9.204h-6.833l3.47-9.204z" fill="#fff" mask="url(#b)"></path><path d="M16.889 8.985V6.28c.262-.02.528-.033.798-.042 7.4-.232 12.255 6.359 12.255 6.359s-5.244 7.282-10.866 7.282a6.82 6.82 0 0 1-2.187-.35v-8.204c2.88.348 3.46 1.62 5.192 4.508l3.852-3.248s-2.812-3.688-7.552-3.688c-.515 0-1.008.036-1.492.088zm0-8.938V4.09c.265-.021.531-.038.798-.048 10.29-.346 16.995 8.44 16.995 8.44s-7.7 9.364-15.723 9.364c-.735 0-1.424-.068-2.07-.183v2.498c.553.07 1.126.112 1.724.112 7.465 0 12.864-3.812 18.092-8.325.867.694 4.416 2.383 5.145 3.123-4.971 4.16-16.555 7.515-23.123 7.515a18.89 18.89 0 0 1-1.838-.096V30h28.375V.047H16.89zm0 19.482v2.133c-6.905-1.23-8.822-8.408-8.822-8.408s3.316-3.674 8.822-4.269v2.34l-.011-.001c-2.89-.347-5.147 2.353-5.147 2.353s1.265 4.544 5.158 5.852zM4.625 12.943s4.092-6.04 12.264-6.663V4.088C7.838 4.815 0 12.48 0 12.48s4.439 12.833 16.889 14.008V24.16C7.753 23.011 4.625 12.943 4.625 12.943z" fill="#76B900" mask="url(#b)"></path></g></svg>
      </div>
    </div>

    <form class="form">
      <div class="cut_login">
        <router-link class="cur" to="/login">{{ $t("login.signIn") }}
          <div class="line"></div>
        </router-link>
        <router-link to="/register">{{ $t("login.signUp") }}
          <div class="line"></div>
        </router-link>
      </div>
<!--      <div class="item mt" style="display: flex;align-items: center;">-->
<!--        &lt;!&ndash; <span class="icon">-->
<!--          <img src="../images/login/tel.png" alt="" />-->
<!--        </span> &ndash;&gt;-->
<!--        <span style="margin-left: 7px">+27</span>-->
<!--        <input type="text" class="inp" v-model.trim="data.username" :placeholder="$t('login.phoneNumber')" />-->
<!--      </div>-->

      <!-- 手机号输入 -->
      <div class="phone-field">
        <van-field
                v-model.trim="data.username"
                type="tel"
                :formatter="formatNumber"
                :placeholder="$t('Phone Number')"
        >
          <template #left-icon>
            <div class="country-trigger" @click="showCountry = true">
              <!--            <span class="flag">{{ country.flag }}</span>-->
              <span class="code">{{ country.dialCode }}</span>
              <van-icon name="arrow-down" />
            </div>
          </template>
        </van-field>
      </div>

      <!-- 国家选择弹窗 -->
      <van-popup v-model="showCountry" position="right" :style="{ width: '100%', height: '100%' }">
        <div class="country-page">
          <div class="country-header">
            <van-search
                    v-model="keyword"
                    shape="round"
                    placeholder="Search country / code"
            />
          </div>

          <van-index-bar :index-list="indexList" highlight-color="#1989fa">
            <div v-for="(group, letter) in filteredGrouped" :key="letter">
              <van-index-anchor :index="letter" />
              <van-cell
                      v-for="item in group"
                      :key="item.iso2"
                      :title="item.name"
                      :label="item.dialCode"
                      @click="selectCountry(item)"
              >
                <template #icon>
                  <span class="cell-flag">{{ item.flag }}</span>
                </template>
              </van-cell>
            </div>
          </van-index-bar>
        </div>
      </van-popup>

      <div class="item mt">
        <!-- <span class="icon"><img src="../images/login/lock.png" alt="" /></span> -->
        <input :type="password" class="inp" v-model.trim="data.password" :placeholder="$t('login.password')" />
        <!-- <div
          class="eye_bi"
          @click="showPwd"
          :class="password == 'text' ? 'eye' : ''"
        ></div> -->
      </div>

<!--      <div class="hqyzm">{{ $t("login.hqyzm") }}</div>-->
      <div class="item_reset_pwd">
        <!-- <van-checkbox v-model="checked" icon-size="14px">{{
          $t("login.remember")
        }}</van-checkbox> -->
        <div class="reset_pwd" @click="goKefu">{{$t("login.forget")}}</div>
<!--        <router-link class="reset_pwd" to="/forgetpwd">{{$t("login.forget")}}</router-link>-->
      </div>
    </form>
    <div type="submit" class="basic_btn sbtn" :class="data.username == '' || data.password == '' ? 'no_touch' : ''"
      @click="submit">
      {{ $t("login.signInBtn") }}
    </div>
    <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="../images/index/kefu.png" />
    </div> -->
<!--    <div class="kf_tips" @click="goKefu">-->
<!--      <img src="../images/index/kefu.png" alt="" />-->
<!--    </div>-->
    <van-number-keyboard v-model="value" :show="showKeyboardz" @blur="Blue()" />
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { CountDown, Checkbox } from "vant";
Vue.use(Checkbox);

export default {
  name: "login",
  data() {
    return {
      value: "",
      showKeyboard: true,
      showKeyboardz: false,
      lang: this.$i18n.locale || "en_us",
      password: "password",
      show_kefu: false,
      msg_show: true,
      checked: true,
      data: {
        username: "",
        password: "",
      },

      showCountry: false,
      keyword: '',
      // 当前选择
      country: { iso2: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
      // 国家数据（你可以扩充/换成完整数据文件）
      countries: [
        { iso2: 'ZA', name: 'South Africa', dialCode: '+27',  flag: '🇿🇦' },
        { iso2: 'EG', name: 'Egypt',        dialCode: '+20',  flag: '🇪🇬' },
        { iso2: 'MA', name: 'Morocco',      dialCode: '+212', flag: '🇲🇦' },
        { iso2: 'DZ', name: 'Algeria',       dialCode: '+213', flag: '🇩🇿' },
        { iso2: 'TN', name: 'Tunisia',       dialCode: '+216', flag: '🇹🇳' },
        { iso2: 'NG', name: 'Nigeria',       dialCode: '+234', flag: '🇳🇬' },
        { iso2: 'GH', name: 'Ghana',         dialCode: '+233', flag: '🇬🇭' },
        { iso2: 'SN', name: 'Senegal',       dialCode: '+221', flag: '🇸🇳' },
        { iso2: 'CI', name: 'Ivory Coast',   dialCode: '+225', flag: '🇨🇮' },
        { iso2: 'CM', name: 'Cameroon',      dialCode: '+237', flag: '🇨🇲' },
        { iso2: 'KE', name: 'Kenya',         dialCode: '+254', flag: '🇰🇪' },
        { iso2: 'TZ', name: 'Tanzania',      dialCode: '+255', flag: '🇹🇿' },
        { iso2: 'ET', name: 'Ethiopia',      dialCode: '+251', flag: '🇪🇹' }
      ],
    };
  },
  created() {
    this.data.username = localStorage.getItem("login_username");
    this.data.password = localStorage.getItem("login_password");
    this.$parent.footer("user", false);
  },
  watch: {
    arr(val) {
      this.code = val.join('')
    }
  },
  computed: {
    // A-Z 索引
    indexList() {
      return Object.keys(this.filteredGrouped);
    },

    // 分组：按国家名首字母
    grouped() {
      const map = {};
      this.countries.forEach(c => {
        const letter = (c.name[0] || '#').toUpperCase();
        (map[letter] || (map[letter] = [])).push(c);
      });
      // 每组排序
      Object.keys(map).forEach(k => map[k].sort((a,b)=>a.name.localeCompare(b.name)));
      return map;
    },

    // 搜索过滤 + 分组
    filteredGrouped() {
      const kw = this.keyword.trim().toLowerCase();
      const list = !kw
              ? this.countries
              : this.countries.filter(c =>
                      c.name.toLowerCase().includes(kw) ||
                      c.dialCode.includes(kw.replace(/\s/g, '')) ||
                      c.iso2.toLowerCase().includes(kw)
              );

      const map = {};
      list.forEach(c => {
        const letter = (c.name[0] || '#').toUpperCase();
        (map[letter] || (map[letter] = [])).push(c);
      });
      Object.keys(map).forEach(k => map[k].sort((a,b)=>a.name.localeCompare(b.name)));
      return map;
    },
  },
  mounted() {

    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
  },
  methods: {
    formatNumber(val) {
      return val.replace(/\D/g, '') // 只保留数字
    },
    selectCountry(item) {
      this.country = item;
      this.showCountry = false;
      this.keyword = '';
    },
    // 提交给后端：E.164 格式（+国家码 + 纯数字）
    getE164() {
      const national = (this.phone || '').replace(/\D/g, '');
      return `${this.country.dialCode}${national}`;
    },
    Focus(e) {
      console.log(e);
      this.showKeyboard = true;
      this.showKeyboardz = true;
    },
    Blue(e) {
      console.log(e);
      this.showKeyboardz = false;
    },
    sendCode() {
      const phone = '+63' + this.data.username
      Fetch("/sms/sendsms", {
        phone
      })
    },
    goKefu() {
      Fetch('/index/webconfig', {type: 'web'}).then(res => {
        this.data = res.data;
        let link=res.data.kefu_link;
        link=link.replace("{0}","");
        window.location.href = link;
      })
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    submit() {
      if (!this.data.username) {
        this.$toast(this.$t("login.phoneEmpty"));
        return;
      }

      if (!this.data.password) {
        this.$toast(this.$t("login.passwordEmpty"));
        return;
      }

      // var regex = /^[A-Za-z0-9]{1,20}$/;
      // if (!regex.test(this.data.username)) {
      //     this.$toast(this.$t('login.phoneError'));
      //     return;
      // }

      if (this.checked) {
        localStorage.setItem("login_username", this.data.username);
        localStorage.setItem("login_password", this.data.password);
      }

      if (!this.checked) {
        localStorage.removeItem("login_username");
        localStorage.removeItem("login_password");
      }

      // 拼接账号
      const e164 = this.getE164();
      var mobile = e164 + this.data.username;

      Fetch("/index/login", {
        username: mobile,
        password: this.data.password,
      })
        .then((res) => {
          if (res.data.token) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user_id", res.data.id);
            localStorage.setItem("user_name", res.data.phone);
          }
          localStorage.removeItem("indexPop");
          this.$toast({
            background: "#07c160",
            message: this.$t("login.signInSuccess"),
          });
        })
        .then(() => {
          this.$router.replace({
            path: this.$router.history.current.query.redirect || "/",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
  .back_left {
    position: absolute;
  }
.login_bg {
  width: 100%;
  height: 300px;
  overflow: hidden;
  background-color: #000;
  clip-path: ellipse(100% 100% at 50% 0%);
  -webkit-clip-path: ellipse(100% 100% at 50% 0%);
  position: relative;
  z-index: 1;
  padding-top: 15px;

   //background: url(../images/login/login_bg.png) no-repeat center center;
   //background-size: 100% 100%;
  .language {
    position: absolute;
    top: 40px;
    right: 15px;
    height: 36px;
    img {
      height: 100%;
    }
  }
}

/deep/ .van-password-input__security {
  justify-content: space-between;
  align-items: center;
}

/deep/ .van-password-input__security li {
  background-color: #f3f3f3;
  width: 30px;
  height: 30px;
  flex: 0.15;
}

.hqyzm {
  width: 80%;
  height: 25px;
  margin: 0 auto;
  background: #3f4141;
  border-radius: 10px;
  margin-top: 20px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 25px;
  text-align: center;
}

.title-img {
  position: absolute;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);

  img {
    height: 32px;
  }
}

.basic_wrap {

     //height: 100vh;
     //overflow: hidden;
     //-webkit-overflow-scrolling: touch;
     //background-color: #fff;
  .form {
    margin: -165px auto 0 auto;
    width: 90%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 0 24px;
    position: relative;
    z-index: 2;
  }
}

.cut_login {
  //   width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin: 0 auto;
  border-radius: 100px;
  overflow: hidden;
  background-color: #f3f3f3;
  color: #c4c5c6;

  a {
    width: 50%;
    // padding: 3px 0;
    // padding-bottom: 10px;
    color: #9e9e9e;
    position: relative;

    // .line {
    //   width: 100%;
    //   height: 1px;
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   background-color: #f2f2f2;
    // }
  }

  a.cur {
    color: #fff;
    background-color: #76b900;

    .line {
      height: 2px;

      //   background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}

.mt {
  margin-top: 20px;
}

.item {
  //   border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;

  .icon {
    width: 32px;
    height: 27px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  input {
    background-color: #f3f3f3;
    border-radius: 100px;
    padding: 15px;
    height: 40px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #5147de;
  text-align: center;
  margin: 20px 0;
  line-height: 60px;
}

.van-checkbox {
  margin-top: 20px;
}

.reset_pwd {
  color: #0009;
  margin-top: -20px;
  display: block;
}

.basic_btn {
  margin: 39px auto 0 auto;
  width: 80% !important;
  background: #76b900 !important;
  color: #000;
  font-weight: 700;
  font-size: 16px;
  border-radius: 10px;
}

.send {
  margin: 20px auto 0 auto;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}

.kf_tips{
  position: absolute;
  top: 40px;
  right: 18px;
  height: 31px;
  z-index: 9;
  img{
    height: 100%;
  }
}

  .custom-input {
    background-color: #f3f3f3;
    border-radius: 100px;
    padding: 15px;
    height: 40px;
    flex: 1;
    margin-bottom: 3px;
  }
  .country-trigger{
    display:flex; align-items:center; gap:6px;
    padding-right:6px; color:#1989fa; font-size:14px;
  }
  .flag{ font-size:16px; }
  .code{ font-weight:500; }
  .country-page{ height:100%; background:#fff; }
  .country-header{ padding:12px 12px 0; }
  .cell-flag{ font-size:18px; margin-right:8px; }
</style>
